import { render } from "./HeaderActions.vue?vue&type=template&id=3a9d7928&scoped=true"
import script from "./HeaderActions.vue?vue&type=script&lang=js"
export * from "./HeaderActions.vue?vue&type=script&lang=js"

import "./HeaderActions.vue?vue&type=style&index=0&id=3a9d7928&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9d7928"]])

export default __exports__